<cb-dialog dialogHeading="Quote Line">
    @if (canGenerateChangesForQuoteLines()) {
        <cb-info-message
            [message]="'Submitting this Quote will generate the following Changes.'"
        ></cb-info-message>
        @for (key of keys; track key) {
            <div class="cb-margin-top">
                <div class="cb-margin-bottom">
                    <strong>
                        {{
                            variationsToGenerate[key][0]?.costNatureId
                                | cbEnumToLabel: COST_NATURE_ENUM
                        }}</strong
                    >
                </div>
                <cb-table [loaded]="true">
                    <thead cbTableHead>
                        <tr>
                            <td>Ref</td>
                            <td>Product/Description</td>
                            <td style="text-align: right">Rate</td>
                        </tr>
                    </thead>
                    <tbody cbTableBody>
                        @for (
                            variationQuoteLine of variationsToGenerate[key];
                            track variationQuoteLine
                        ) {
                            <tr>
                                <td>{{ variationQuoteLine.reference }}</td>
                                <td>{{ variationQuoteLine.description | cbDasher }}</td>
                                <td style="text-align: right">
                                    {{ variationQuoteLine.allocatedAmount | cbCurrency }}
                                </td>
                            </tr>
                        }
                        <tr>
                            <td></td>
                            <td>
                                <strong>Variation Total</strong>
                            </td>
                            <td style="text-align: right">
                                <strong>{{
                                    calcVariationTotal(variationsToGenerate[key]) | cbCurrency
                                }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </cb-table>
            </div>
        }
    }
    @if (!canGenerateChangesForQuoteLines() || isVariationsEmpty()) {
        <cb-info-message [message]="getNoChangesMessage()" [icon]="'info_circle'">
        </cb-info-message>
    }
    <div actions>
        <button mat-raised-button color="primary" (click)="submitQuote()">Submit</button>
        <button class="raised" mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
